// TEMPORARY (EL-15382): agreed stop-gap for a customer request, to be reverted once
// work order categories are configurable per building. Do not add more buildings here.
// Building-specific categories replace the default ElevateOS list and are shown verbatim
// (not translated) - they are customer-defined, like PMS categories.
const HURON_AT_100_EAST_BUILDING_ID = 1020

const CUSTOM_MAINTENANCE_CATEGORIES: Record<number, string[]> = {
  [HURON_AT_100_EAST_BUILDING_ID]: [
    'HVAC',
    'HVAC (Filter changes only)',
    'Common Areas',
    'Smoke/Carbon Monoxide Detectors',
    'Windows',
    'Water Shutdown',
    'Vent/Damper',
    'Electric',
    'Key/Fob Replacement',
    'Mail Hold',
    'Walk through (1 time)',
    'Walk through (monthly)',
    'Lock and/or Doors',
    'Leaks',
    'Paint/Cosmetics',
    'Plumbing',
    'Christmas Tree Removal - Fee applies!',
  ],
}

export const getCustomMaintenanceCategories = (buildingId?: number | string): string[] | null =>
  CUSTOM_MAINTENANCE_CATEGORIES[Number(buildingId)] ?? null
